import { Button } from "@livingmap/hippo";

import styles from "./Modal.module.scss";

interface Props {
  acceptLabel: string;
  summary: string;
  closeModal: () => void;
  onRunWorkflow: () => void;
}

const RunWorkflow: React.FC<Props> = ({
  acceptLabel,
  summary,
  closeModal,
  onRunWorkflow,
}) => {
  const handleRunWorkflow = () => {
    onRunWorkflow();
    closeModal();
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>{summary}</p>
      <div className={styles.buttonWrapper}>
        <Button
          dataQA="cancel-button"
          type="primary"
          size="regular"
          style="filled"
          text="Cancel"
          onClick={closeModal}
        />
        <Button
          dataQA="okay-button"
          type="location"
          size="regular"
          style="filled"
          text={acceptLabel}
          onClick={handleRunWorkflow}
        />
      </div>
    </div>
  );
};

export default RunWorkflow;
